import React from 'react';
import { Box, ButtonGroup } from '@chakra-ui/react';
import LinkButton from '../../../components/custom/LinkButton';
import AddTechnologyForm from '../../../components/forms/technology/AddTechnologyForm';
import PageHeader from '../../../components/common/PageHeader';

export default function AddTechnology() {
    return (
        <>
            <div className='admin-page-header'>
                <PageHeader headerTitle={'技術登録'} />
                <ButtonGroup gap={2}>
                    <LinkButton buttonText={'戻る'} buttonUrl={'/technologies'}/>
                </ButtonGroup>
            </div>
            <Box className='admin-box'>
                <AddTechnologyForm />
            </Box>
        </>   
    ) 
}
